import { FaApple } from 'react-icons/fa';
import { Button } from 'ui/components/common';

const AppleSigninButton = ({ isLoading }: { isLoading: boolean }) => {
  const isDev = import.meta.env.VITE_APP_ENV === 'DEV';

  if (isDev) return null;

  const handleAppleLogin = () => {
    const state = randStr(24);
    const nonce = randStr(24); // save server-side or send to server to be verified
    const params = new URLSearchParams({
      response_type: 'code id_token',
      response_mode: 'form_post', // recommended when asking for name/email
      client_id: import.meta.env.VITE_APP_APPLE_CLIENT_ID,
      redirect_uri: import.meta.env.VITE_APP_APPLE_REDIRECT_URI,
      scope: 'name email',
      state,
      nonce,
    });
    window.location.href = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
  };

  function randStr(len = 16) {
    return [...Array(len)].map(() => Math.random().toString(36)[2]).join('');
  }
  return (
    <Button
      label="CONTINUE WITH APPLE"
      className="w-full font-semibold bg-secondary-dark text-fill-tertiary"
      intent="tertiary"
      size="md"
      icon={FaApple}
      left
      disabled={isLoading}
      onClick={handleAppleLogin}
    />
  );
};

export default AppleSigninButton;
